// extracted by mini-css-extract-plugin
export default {"container":"Avatar_container_HhS1E","circle":"Avatar_circle_eDZHO","image":"Avatar_image_dNXRu","online":"Avatar_online__hh8p","small":"Avatar_small_uC4f1"};